<form [formGroup]="agentForm" ngNativeValidate>
  <div class="form-wrapper input-wrapper">
    <div class="toggle">
      <mat-slide-toggle formControlName="isDisabled">
        <span class="label">Agent
        @if (agentForm.get('isDisabled')?.value === true) {
          Disabled
        } @else {
          Enabled
        }</span>
      </mat-slide-toggle>
      <mat-hint class="hint">Sets whether the Agent is enabled or disabled for use.</mat-hint>
    </div>

    <div class="toggle">
      <mat-slide-toggle formControlName="isUniversal">
        <span class="label">Agent
        @if (agentForm.get('isUniversal')?.value === true) {
          set to Universal
        } @else {
          is not Universal
        }</span>
      </mat-slide-toggle>
      <mat-hint class="hint">Bypasses the security check and makes it available to use for everyone. The "owners"
        permissions stand. It ignores the Granted Users and let's everyone use it. </mat-hint>
    </div>
  </div>
</form>
